export const defaultExpenseCategories = [
  'Gasoline',
  'Car Maintenance and Repairs',
  'Car Lease Payments',
  'Parking Fees and Tolls',
  'In Car Entertainment',
  'Car Wash / Cleaning',
  'Garage Rent',
  'Snacks & Drinks for Clients (50%)',
  'Other Vehicle Related Expenses',
  'Car Insurance',
  'Mobile Phone Plan',
  'Electronics (Phone, Laptop, etc.)',
  'Software',
  'Tools',
  'Business Travel',
  'Reimbursement',
  'Office Expenses',
  'Advertising and Marketing',
  'Legal / Professional Services',
  'Professional Dues and Fees',
  'Postage, Packaging, and Shipping',
  'Business Gifts (Up to $25)',
  'Business Meals & Entertainment',
  'Referral and Commission Fees',
  'Retirement Plan Contributions',
  'Professional Journal Subscriptions',
  'Real Estate Franchise Fees',
  'Cleaning',
  'Non-vehicle Related Insurance',
  'Loan Interest (Small business, etc.)',
  'Inventory',
  'Supplies',
  'Home Office Deductions',
  'Depreciation and Section 179',
  'Education and Training',
  'Other Business Expenses',
  'Charitable Donation'
]
